"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exists = exists;
exports.parse = parse;
exports.toAbsolutePaths = toAbsolutePaths;
exports.hasExpired = hasExpired;
const fs_1 = require("fs");
const yaml_1 = require("yaml");
const path_1 = require("path");
/**
 * Checks if the snyk policy file exists in the provided path
 * @param {string} policyPath - the path of the policy file.
 * @returns {[boolean, Object]} - snyk policy file is present or not and the error in case of failure
 */
function exists(policyPath) {
    return (0, fs_1.existsSync)(policyPath);
}
/**
 * Parses the snyk policy file content
 * @param {string} policyPath - the path of the policy file.
 * @returns {Object} - the content of the policy file
 */
function parse(policyPath) {
    return (0, yaml_1.parse)((0, fs_1.readFileSync)(policyPath, 'utf-8'));
}
/**
 * Resolves an array of paths relative to the basedir
 * @param {string} basedir - the basedir used for resolving the paths
 * @param {Array} paths - the paths to be resolved
 * @returns {Array} - the resolved paths
 */
function toAbsolutePaths(basedir, paths = []) {
    return paths.map((p) => (0, path_1.resolve)(basedir, p));
}
/**
 * Resolves an array of paths relative to the basedir
 * @param {string} expires - date string
 * @returns {boolean} - whether or not the provided date has expired
 */
function hasExpired(expires) {
    if (expires === null || expires === undefined) {
        return false;
    }
    if (isNaN(Date.parse(expires))) {
        throw `Invalid date format provided dates should be formatted as "yyyy-MM-ddTHH:mm:ss.fffZ"`;
    }
    return new Date() > new Date(expires);
}
//# sourceMappingURL=index.js.map